import React from "react";
import Link from "helpers/link";
import { formatTitle } from "helpers/format-title";
//TODO:Show empty state if no ingredients are found

const Category = ({ data, search }) => {
	const { title, ingredients } = data;

	const filteredIngredients = search
		? ingredients.filter((ingredient) => ingredient.title.toLowerCase().startsWith(search.toLowerCase()))
		: ingredients;

	if (!filteredIngredients.length) return;

	return (
		<div className="my-4 md:my-0">
			<h2 className="text-h4">{formatTitle(title)}</h2>
			<ul className="list-none mt-5 m-0">
				{filteredIngredients.map((ingredient) => (
					<li className="my-2 hover:underline" key={ingredient.handle}>
						<Link to={`/lexicon/${ingredient.handle}`}>{ingredient.title}</Link>
					</li>
				))}
			</ul>
		</div>
	);
};

export default Category;
